import { Link } from 'react-router-dom'
import React, {useContext, useEffect, useState} from 'react'
import MUIDataTable from 'mui-datatables'
import api from '../../services/api'
import { DataTableOptions } from '../../components/dataTableOptions'
import {MainContext} from "../../context/MainContext";
import IEventTypes from "../../interfaces/IEventTypes";

export default function ListingEventType() {
  const {setPageTitle, setLoading} = useContext(MainContext)
  const [eventTypes, setEventTypes] = useState([] as any)

  const getEventTypes = async () => {
    await api.get<IEventTypes>('/api/eventTypes').then((response) => {
      setEventTypes(response.data)
    })
  }

  useEffect(() => {
    setPageTitle("Eventos")
    setLoading(true)

    const fetchData = async () => {
      await getEventTypes()
    };

    fetchData().then(setLoading(false))
  }, [])

  const columns: any = [
    {
      name: 'description', label: 'Descrição', options: {
        filter: false,
        sort: true,
      },
    },
    {
      name: '', label: '', options: {
        filter: false,
        false: true,
        customBodyRenderLite: (index: string | number) => {return (
            <>
              <Link className='btn btn-sm btn-warning' to={`/events/update/${eventTypes[index]?.id}`} title="Editar"><i className="bi bi-pencil" aria-hidden="true"></i> </Link>
            </>
          )
        },
      },
    },
  ]

  const options: any = DataTableOptions

  return (
    <>

      <div className='mb-4'>
        <Link className='btn btn-success mb-3' to='/events/create'><i className="bi bi-plus-circle">&nbsp;</i> Cadastrar Evento</Link>

        <MUIDataTable
          title={''}
          data={eventTypes}
          columns={columns}
          options={options}
        />
      </div>

    </>
  )
}